import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import { useGameStore } from '../store/gameStore';
import { formatTime } from '../utils/encoding';

export const Timer: React.FC = () => {
  const gamePhase = useGameStore((state) => state.gamePhase);
  const elapsedTime = useGameStore((state) => state.elapsedTime);
  const { t } = useTranslation();

  if (gamePhase !== 'playing') return null;

  return (
    <div className="timer">
      {t.timeRemaining}: {formatTime(elapsedTime)}
    </div>
  );
};
